import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductModelService {
  constructor(private ws: PostmethodService) { }

  productModelCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productModelMaster");
  }

  productCategoryList(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productCategoryMaster");
  }
}
